<template>
  <div class="login-wrapper">
    <el-card class="login-box result-card">
      <div class="icon-wrapper">
        <svg class="icon success-anim" aria-hidden="true">
          <use xlink:href="#icon-chenggong"></use>
        </svg>
      </div>

      <div class="result-header">
        <h2 class="accountinfo">注册成功</h2>
        <p class="email-display">{{ email }}</p>
      </div>

      <div class="notice-box">
        <p class="main-notice">
          请在 <span class="highlight">30分钟内</span> 进入您的邮箱查收激活邮件。
        </p>
        <p class="sub-notice">
          点击邮件中的激活链接后即可使用账号。若未收到，请检查垃圾箱或尝试重新注册。
        </p>
      </div>

      <div class="action-area">
        <el-button type="primary" class="back-btn" @click="background">返回登录页面</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import "../assets/fonts/iconfont.js";
export default {
  data() {
    return {
      email: ""
    }
  },
  created() {
    // 从 sessionStorage 获取注册时存入的邮箱
    this.email = window.sessionStorage.getItem("register") || "您的邮箱"
  },
  methods: {
    background() {
      this.$router.push('/login')
    }
  }
};
</script>

<style lang="less" scoped>
/* 1. 基础布局：与登录/注册页完全统一 */
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}

/* 2. 卡片容器 */
.login-box {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  border: none;
  padding: 20px;
  text-align: center;
}

/* 3. 图标动画与样式 */
.icon-wrapper {
  margin-top: 20px;
  .icon {
    width: 80px;
    height: 80px;
    fill: #67c23a; /* Element 成功绿 */
    margin: 0 auto;
    display: block;
  }
}

/* 4. 标题与邮箱显示 */
.result-header {
  margin: 20px 0;
  .accountinfo {
    font-size: 24px;
    color: #303133;
    margin-bottom: 8px;
    font-weight: 600;
  }
  .email-display {
    font-size: 16px;
    color: #606266;
    word-break: break-all;
  }
}

/* 5. 提示框样式（去掉了刺眼的纯红背景） */
.notice-box {
  background-color: #fdf6ec; /* 柔和的警告橙背景 */
  border: 1px solid #faecd8;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  text-align: left;
  
  .main-notice {
    color: #e6a23c;
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 14px;
    .highlight {
      color: #f56c6c;
      text-decoration: underline;
    }
  }
  .sub-notice {
    color: #909399;
    font-size: 13px;
    line-height: 1.6;
  }
}

/* 6. 按钮区域 */
.action-area {
  margin-bottom: 10px;
  .back-btn {
    width: 100%;
    height: 42px;
    font-size: 16px;
    border-radius: 8px;
  }
}

/* 7. 移动端适配 */
@media screen and (max-width: 768px) {
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 10vh;
  }
  .login-box {
    width: 100%;
    box-shadow: none;
  }
}
</style>